module.exports = __webpack_public_path__ + "img/route_reverse.d4308ee5.svg";